var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TooltipEffect',_vm._b({attrs:{"color":_vm.color,"message":_vm.message,"text":_vm.text},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-icon',_vm._g({attrs:{"size":_vm.size,"color":_vm.color}},on),[_vm._v(_vm._s(_vm.icon))])]}}])},'TooltipEffect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }